import React from 'react';

interface WeatherData {
  temperature: number;
  condition: string;
  location: string;
  icon?: string;
}

interface WeatherWidgetProps {
  weatherData?: WeatherData;
  isLoading?: boolean;
}

const WeatherWidget: React.FC<WeatherWidgetProps> = ({ weatherData, isLoading = false }) => {
  if (isLoading) {
    return (
      <div className="flex items-center text-sm text-theme text-shadow">
        <span className="animate-pulse">Weer laden...</span>
      </div>
    );
  }

  if (!weatherData) {
    return null;
  }

  // Get weather icon based on condition
  const getWeatherIcon = (condition: string): string => {
    switch (condition.toLowerCase()) {
      case 'clear':
      case 'sunny':
        return '☀️';
      case 'partly cloudy':
        return '⛅';
      case 'cloudy':
        return '☁️';
      case 'rain':
      case 'rainy': 
        return '🌧️';
      case 'thunderstorm':
        return '⛈️';
      case 'snow':
      case 'snowy':
        return '❄️';
      case 'fog':
      case 'foggy':
        return '🌫️';
      default:
        return '🌤️';
    }
  };

  return (
    <div className="flex items-center text-sm text-theme text-shadow">
      <span className="text-xl mr-2">
        {weatherData.icon || getWeatherIcon(weatherData.condition)}
      </span>
      <span>
        {weatherData.temperature}° {weatherData.location}
      </span>
    </div>
  );
};

export default WeatherWidget; 